<template>
  <b-row id="discounts-mindfulness" class="section-white-list reverse-sm">
           <b-col md="12" lg="6">
      <div class="col-bg ml-lg-auto"></div>
    </b-col>
    <b-col md="12" lg="6" class="content my-auto">
      <h3 style="color:#3238c4">{{ $t('discounts-mindfulness.title') }}</h3>
      <p class="text-info text-section-one"
        v-html="$t('discounts-mindfulness.subtitle')">
      </p>
      <p class="text-info text-section-one"
        v-html="$t('discounts-mindfulness.subtitle2')">
      </p>
      <p class="text-info text-section-one"
      v-html="$t('discounts-mindfulness.subtitle3')">
      </p>
      <!-- <base-button class="btn-more-info" outline @click="$helpers.goToWebApp('opensaludprime/bienestar')"><span>{{ $t('more-info-btn') }}</span></base-button> -->
    </b-col>
  </b-row>
</template>

<script>
import es from '@/lang/es/public/views/mindfulness.json'
import en from '@/lang/en/public/views/mindfulness.json'
export default {
    i18n: {
    messages: {
      es,
      en,
      mx: es
    }
  }
}
</script>

<style lang="scss">
  @import "../../../static-appopensalud/css/public/layout.scss";
  #discounts-mindfulness {
    margin-top: 0px;
  }
  #discounts-mindfulness .text-section-one{
    font-size: 1.5rem;
    @include mobile {
      font-size: 1rem;
    }
    margin-top: 3rem;
    margin-bottom: 3rem;
  }
  #discounts-mindfulness .text-section-two{
    font-size: 1.2rem;
    margin-top: 3rem;
    margin-bottom: 3rem;
  }
  #discounts-mindfulness .col-bg {
    background-image: url(/static-appopensalud/img/bgs/opt/saludmental4.png),
      linear-gradient(273deg, #ffffff96, transparent) !important;
    background-position: center;
    background-blend-mode: overlay;
  }
  @media (max-width: 1268px) {
    #discounts-mindfulness > div.content.my-auto.col-md-12.col-lg-6 > div > div > div > p {
      font-size: 1rem;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/public/DiscountsMindfulness.vue